module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("My gratitude to all who helped, in particular:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Brigadier Henry Wilson and his team at Pen & Sword Ltd, my publishers, especially my liaison officer Matt Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Johnson & Alcock Ltd, my agents, especially my liaison officer Ed Wilson.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Pamela Covey, my editor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Jon Wilkinson, who had the brilliant idea of having a Russian Hurricane on the cover as a symbol of the Hurricane’s worldwide service.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("The Birmingham & Midland Institute & Library, the Taylor Library and Mr Christopher Shores for the photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Thank you everyone.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bbbc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0